import { html, nothing } from 'lit';

export const hostIsWhitelisted = (host) => {
  const domains = drupalSettings.healthfirst_components.whitelisted;
  const domainsArray = domains.replace(/[\r]/g, '').split('\n');
  return domainsArray.includes(host);
};

export const isExternalUrl = (url) => {
  const tmp = document.createElement('a');
  tmp.href = url;
  const hostname = tmp.host;
  return (drupalSettings.isHPSite && (hostname !== window.location.host) && tmp.protocol !== 'tel:' && !hostIsWhitelisted(hostname) || hostname.endsWith('.pdf'))
};

export const isExternalLink = (link) => (
  (link.host !== window.location.host) && link.protocol !== 'tel:' && !hostIsWhitelisted(link.host) || link.host.endsWith('.pdf')
);

export const leavingSiteAlertHandler = () => {
  return drupalSettings.isHPSite ?? true;
};

export const externalLinkHoverText = (title = '') => {
  let titleWithHoverText;
  if (title.length > 0) {
    titleWithHoverText = title + ' - ' + Drupal.t(drupalSettings.healthfirst_components.hover_text)
  } else {
    titleWithHoverText = Drupal.t(drupalSettings.healthfirst_components.hover_text)
  }

  return drupalSettings.isHPSite ? titleWithHoverText : title;
};

export const renderIcon = (url, ignoreExternalUrl) => {
  if (isExternalUrl(url) && !ignoreExternalUrl) {
    return html`
      <hf-icon name="external-link" class="link--external__icon"></hf-icon>`
  } else {
    return nothing
  }
};
